import { PropsWithChildren } from "react";
import { Label, Icon, DarkButton, LightButton } from "./styles";

type Props = PropsWithChildren<{
  className?: string;
  onClick?: () => void;
  colorScheme?: "dark" | "light";
}>;

const RemoveButton: React.FC<Props> = (props) => {
  const { className, onClick, children, colorScheme } = props;
  const Container = colorScheme === "light" ? LightButton : DarkButton;

  return (
    <Container className={className} onClick={onClick}>
      <Label>{children}</Label>
      <Icon />
    </Container>
  );
};

export default RemoveButton;
